module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/img_security-9f7885494b615c3cd05a9f4f28c02a0b.png";